<template>
  <header>
    <md-toolbar md-elevation="1">
      <h3 class="md-title" style="flex: 1">
        <router-link :to="{name: 'MapLogin'}" v-if="![
            '/trial/email',
            '/trial/apply',
            '/trial/start',
            '/contract/email',
            '/contract/verify',
            '/contract/apply',
            '/contract/preview',
            '/contract/complete'
        ].includes($route.path)">
          <img src="https://cdn.jon-api.com/shikaku-map/img/logo.png">
        </router-link>
        <div v-else>
          <img src="https://cdn.jon-api.com/shikaku-map/img/logo.png">
        </div>
      </h3>
      <router-link :to="{name: 'MapLogin'}" class="md-raised md-primary" tag="md-button"
                   v-if="![
                    '/terms',
                    '/legal',
                    '/payment',
                    '/trial/email',
                    '/trial/apply',
                    '/trial/start',
                    '/simulation',
                    '/contract/email',
                    '/contract/verify',
                    '/contract/apply',
                    '/contract/preview',
                    '/contract/complete',
                    '/faq'
                   ].includes($route.path)">
        <span>ログイン</span>
        <md-icon>arrow_right</md-icon>
      </router-link>
      <a href="https://www.jon.co.jp/aboutus/company/" rel="noopener" target="_blank"
         v-if="['/simulation'].includes($route.path)">
        <md-button class="md-raised">
          <span>企業情報</span>
          <md-icon>apartment</md-icon>
        </md-button>
      </a>
      <md-button @click="toContact" class="md-raised"
                 v-if="![
                    '/forgot-account',
                    '/reminder',
                    '/faq'
                   ].includes($route.path)">
        <span>お問い合わせ</span>
        <md-icon>arrow_right</md-icon>
      </md-button>
    </md-toolbar>
  </header>
</template>

<script>
export default {
  name   : 'Header',
  methods: {
    toContact() {
      window.open('https://www.jon.co.jp/contact/', '_blank');
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components.scss";

.md-title img {
  height: 52px;
  margin: 4px 0;
}
</style>
